// Routing module for the upload module. Includes "new" and "list" routes.
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListComponent } from './views/list/list.component';
import { FileUploadComponent } from './views/upload/upload.component';
import { JwtGuard } from '../shared/guards/jwt.guard';
import { RoleGuard } from '../shared/guards/role.guard';
import { FoldersComponent } from './views/folders/folders.component';
import { ReviewComponent } from './views/review/review.component';
import { UserRole } from '../shared/services/user-role/user-role.service';
import { FoldersLeftNavComponent } from './views/folders-left-nav/folders-left-nav.component';
import { FoldersLeftLayoutComponent } from './views/folders-left-layout/folders-left-layout.component';

const routes: Routes = [
  {
    path: 'upload',
    component: FileUploadComponent,
    canActivate: [JwtGuard]
  }, {
    path: 'list',
    component: ListComponent,
    canActivate: [JwtGuard]

  }, {
    path: 'folders',
    component: FoldersComponent,
    canActivate: [JwtGuard]

  }, {
    path: 'folders-v2',
    component: FoldersLeftNavComponent,
    canActivate: [JwtGuard]

  }, {
    path: 'folders-v3',
    component: FoldersLeftLayoutComponent,
    canActivate: [JwtGuard]

  }, {
    path: 'review',
    component: ReviewComponent,
    canActivate: [JwtGuard, RoleGuard],
    data: { roles: [UserRole.MANAGER, UserRole.SUPERVISOR, UserRole.SUPER_ADMIN] }
  }, {
    path: '**',
    redirectTo: 'upload'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FilesRoutingModule { }